'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _project = require('redux/modules/project');

var _AddRecipientRow = require('components/Recipients/AddRecipientRow/AddRecipientRow');

var _AddRecipientRow2 = _interopRequireDefault(_AddRecipientRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var EmailField = (_dec = (0, _reactRedux.connect)(null, { loadRecipientsList: _project.loadRecipientsList }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(EmailField, _Component);

  function EmailField() {
    (0, _classCallCheck3.default)(this, EmailField);
    return (0, _possibleConstructorReturn3.default)(this, (EmailField.__proto__ || (0, _getPrototypeOf2.default)(EmailField)).apply(this, arguments));
  }

  (0, _createClass3.default)(EmailField, [{
    key: 'onAddGroup',
    value: function onAddGroup() {
      var projectId = this.props.projectId;

      this.props.loadRecipientsList(projectId);
    }
  }, {
    key: 'render',
    value: function render() {
      var projectId = this.props.projectId;


      return _react2.default.createElement(_AddRecipientRow2.default, {
        projectId: projectId,
        formRowClassName: 'formRow simple wide',
        hintClassName: '',
        withTags: true,
        onAddGroup: this.onAddGroup,
        required: true
      });
    }
  }]);
  return EmailField;
}(_react.Component), _class3.propTypes = {
  loadRecipientsList: _propTypes2.default.func,
  projectId: _propTypes2.default.number
}, _class3.defaultProps = {
  prop: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onAddGroup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onAddGroup'), _class2.prototype)), _class2)) || _class);
exports.default = EmailField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/form/EmailField.js
// module id = 838
// module chunks = 1